module.exports = {
  WAGE: 'wage',
  COMMISSION: 'commission'
}
